import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Error404Component } from './main/shared/components/error/error-404/error-404.component';
import { MaintenanceComponent } from './main/shared/components/maintenance/maintenance.component';

const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'order/list',
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent,
  },
  {
    path: '404-not-found',
    pathMatch: 'full',
    component: Error404Component,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
